import { Drawer, Tooltip } from "@mui/material";
import IconButton from "@mui/material/IconButton";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import { styled } from "@mui/material/styles";
import { t } from "i18next";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import logo50Piu from "../../../../../public/img/50+/logo_sidebar.png";
import logoEnasco from "../../../../../public/img/enasco/logo_sidebar.png";
import { actions } from "../../../../app/appSlice";
import CustomArrowIcon from "../../../../app/assets/custom-icons/CustomArrowIcon";
import CustomMenuIcon from "../../../../app/assets/custom-icons/CustomMenuIcon";
import CoreIAicon from "../../../../app/core/components/CoreIAicon/CoreIAicon";
import { useGetProfileUserQuery } from "../../../../features/api/user/modificaProfiloApi"; // aggiungi questo import
import { useGetTenantQuery } from "../../../../features/api/user/tenantApi";
import { ROLE } from "../../../../utils/constants/profiles";
import SwitchTenant from "../Topbar/itemsList/SwitchTenant/SwitchTenant";
import CoreModal from "../../../../app/core/components/CoreModal/CoreModal";

const drawerWidth = 270;
const closedDrawerWidth = 65;

const CustomDrawer = styled(Drawer, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  width: drawerWidth,
  flexShrink: 0,
  whiteSpace: "nowrap",
  boxSizing: "border-box",
  zIndex: theme.zIndex.drawer + 2,
  ...(open && {
    ...openedMixin(theme),
    "& .MuiDrawer-paper": openedMixin(theme),
  }),
  ...(!open && {
    width: closedDrawerWidth,
    overflowX: "hidden",
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    "& .MuiDrawer-paper": {
      width: closedDrawerWidth,
      transition: theme.transitions.create("width", {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
      }),
    },
  }),
}));

const openedMixin = (theme) => ({
  width: drawerWidth,
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflowX: "hidden",
});

const Sidebar = ({ routes, open, setOpen, DrawerHeader }) => {
  const appConfig = useSelector((state) => state.app.appConfig);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const redux = useSelector((state) => state.app);
  const role = useSelector((state) => state.app.role);
  const tenantId = useSelector((state) => state.app.tenantId);
  const reduxProfile = useSelector((state) => state.app.profile);
  const multiTenant = useSelector((state) => state.app.hasMultiTenant);
  const requireUser = appConfig?.modules?.profile;
  const [switchTenant, setSwitchTenant] = useState(false);
  const [logoStudio, setLogoStudio] = useState();
  const { data: dataProfile } = useGetProfileUserQuery(undefined, {
    skip: role !== ROLE.USER,
  });

  const isProfileRoute =
    location.pathname.includes(t("profile")) ||
    location.pathname.endsWith(t("profile"));

  const isProfileIncomplete =
    role === ROLE.USER &&
    isProfileRoute &&
    !dataProfile?.Data?.isCompany &&
    Object.keys(requireUser)
      .map((key) => requireUser[key] && !reduxProfile[key])
      .some((value) => value);

  const [selectedRoute, setSelectedRoute] = useState(
    location.pathname.split("/").pop()
  );

  const { data: getTenantList } = useGetTenantQuery();

  useEffect(() => {
    if (tenantId && getTenantList) {
      const tenant = getTenantList.Data.find((el) => el.id === tenantId);
      if (tenant.description === "Enasco") {
        setLogoStudio(logoEnasco);
        if (role === ROLE.ADMIN) {
          dispatch(
            actions.setColors({
              primaryColor: tenant.primaryColor,
              secondaryColor: tenant.secondaryColor,
            })
          );
        }
      } else if (tenant.description === "50&piu") {
        setLogoStudio(logo50Piu);
        if (role === ROLE.ADMIN) {
          dispatch(
            actions.setColors({
              primaryColor: tenant.primaryColor,
              secondaryColor: tenant.secondaryColor,
            })
          );
        }
      } else {
        setLogoStudio(redux.logoImageURL);
      }
    }
  }, [tenantId, getTenantList, redux?.logoImageURL, dispatch, role]);

  const returnLogoStudio = () => {
    if (logoStudio) {
      return (
        <div
          className={`bg-background w-full flex flex-row items-center ${
            open ? "justify-end" : "justify-center"
          }`}
        >
          {open ? (
            <div className="flex flex-row w-full items-center justify-between py-4 px-2">
              <div className="h-16 flex flex-row items-center">
                {appConfig?.modules?.logoPlaceHolder ? (
                  <>
                    <img
                      alt="logo"
                      src={appConfig?.assets?.imgs?.logoExt}
                      className="max-w-full max-h-full"
                    />
                  </>
                ) : multiTenant !== "False" && role === ROLE.USER ? (
                  <button
                    className="border-none bg-transparent
                       cursor-pointer"
                    onClick={() => setSwitchTenant(true)}
                    disabled={multiTenant === "False"}
                  >
                    <img
                      alt="logo"
                      className="max-w-full max-h-full"
                      src={logoStudio}
                    />
                  </button>
                ) : (
                  <img
                    alt="logo"
                    className="max-w-full max-h-full"
                    src={logoStudio}
                  />
                )}
              </div>

              <IconButton
                className=""
                disableRipple
                onClick={() => setOpen(!open)}
              >
                {open ? (
                  <CustomArrowIcon className="w-6 h-6" />
                ) : (
                  <CustomMenuIcon className="w-8 h-8" />
                )}
              </IconButton>
            </div>
          ) : (
            <div>
              <IconButton onClick={() => setOpen(!open)} disableRipple>
                {open ? (
                  <CustomArrowIcon className="w-6 h-6" />
                ) : (
                  <CustomMenuIcon className="w-8 h-8" />
                )}
              </IconButton>
            </div>
          )}
        </div>
      );
    } else {
      return (
        <div
          className={`bg-background w-full flex flex-row items-center ${
            open ? "justify-end" : "justify-center"
          }`}
        >
          {open ? (
            <div className="flex flex-row w-full  items-center justify-between py-4 px-2">
              <div className="h-12 flex flex-row items-center">
                <img
                  alt="logo"
                  className="w-full h-full"
                  src={appConfig?.assets?.imgs?.logoExt}
                />
              </div>
              <IconButton
                className=""
                disableRipple
                onClick={() => setOpen(!open)}
              >
                {open ? (
                  <CustomArrowIcon className="w-6 h-6" />
                ) : (
                  <CustomMenuIcon className="w-8 h-8" />
                )}
              </IconButton>
            </div>
          ) : (
            <div>
              <IconButton onClick={() => setOpen(!open)} disableRipple>
                {open ? (
                  <CustomArrowIcon className="w-6 h-6" />
                ) : (
                  <CustomMenuIcon className="w-8 h-8" />
                )}
              </IconButton>
            </div>
          )}
        </div>
      );
    }
  };

  return (
    <CustomDrawer variant="permanent" open={open} className="bg-background">
      <DrawerHeader className="bg-background items-center">
        {returnLogoStudio()}
      </DrawerHeader>
      <List
        className="bg-background h-full w-full"
        sx={{ overflowX: "hidden" }}
      >
        {routes
          .filter((route) => route.isSidebarElement)
          .sort((a, b) => a.order - b.order)
          .map((route) => {
            // Disabilita tutte le voci solo se sei sulla pagina profilo e il profilo è incompleto
            const disabled = isProfileIncomplete;
            const lastPathSegment = location.pathname.split("/").pop();
            return (
              <Tooltip
                title={!open ? route.label : ""}
                placement="right"
                key={route.path}
              >
                <ListItem
                  selected={selectedRoute === route.path}
                  className={`text-black font-semibold ${
                    lastPathSegment === route.path ? "bg-grey/70" : ""
                  }`}
                  button
                  disabled={disabled}
                  onClick={() => {
                    if (!disabled) {
                      navigate(route.path);
                      setSelectedRoute(route.path);
                    }
                  }}
                  style={
                    disabled ? { opacity: 0.5, pointerEvents: "none" } : {}
                  }
                >
                  <ListItemIcon>{route.icon}</ListItemIcon>
                  <p primary={route.label} className="text-black font-bold">
                    {route.label}
                    {route.ai && (
                      <>
                        {" "}
                        <CoreIAicon />
                      </>
                    )}
                  </p>
                </ListItem>
              </Tooltip>
            );
          })}
      </List>
      <CoreModal
        width={"50%"}
        height={"50%"}
        state={switchTenant}
        onClose={() => setSwitchTenant(false)}
        component={<SwitchTenant onClose={() => setSwitchTenant(false)} />}
      />
    </CustomDrawer>
  );
};

export default Sidebar;
